module.exports = __webpack_public_path__ + "static/media/ticket-office.45bfd5a9.png";